import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import Chart from './consumptionChart';
import HistoricValues from './historicValues';
import UpdateButton from './updateButton';
import './ordersLimit.scss';

class OrderLimits extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleBackClick = this.handleBackClick.bind(this);
  }

  componentDidMount() {
    const {permissions} = this.props;

    if (
      !hasAccessPermission(
        permissions,
        resources.ProviderOrdersAmountLimits,
        scopes.Edit
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
      return;
    }

    this.props.getProviderOrdersHistoricLimits();
  }

  handleBackClick() {
    this.props.navigateBack();
  }

  render() {
    return (
      <div className='provider-orders-amount-limits'>
        <Card raised fluid className='orders-limit-header'>
          <Grid>
            <Grid.Row>
              <Grid.Column width='10' textAlign='left'>
                <h2>
                  <Icon
                    link
                    color='black'
                    className='arrow left'
                    onClick={this.handleBackClick}
                  />
                  Gestión de montos para pedidos Aéreos y VOR
                </h2>
              </Grid.Column>
              <Grid.Column width='6' textAlign='right'>
                <UpdateButton />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <HistoricValues />
        <Chart />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
  };
};

const {getProviderOrdersHistoricLimits, navigateTo, navigateBack} = Actions;

export default connect(mapStateToProps, {
  getProviderOrdersHistoricLimits,
  navigateTo,
  navigateBack,
})(OrderLimits);
